import React, { useEffect, useState } from "react";
import { Typography } from "antd";
import { t } from "i18next";
import Helper from "../../../core/Helper";
import ApiService from "../../../core/service/ApiService";
import { useDataGrid } from "../../../core/components/data-grid/DataGridContext";
import { useUser } from "../../../core/context/UserContext";

const { Text } = Typography;

export const EntitlementSummaryCard = () => {
    const { queryModel } = useDataGrid();
    const { formatPrice } = useUser();
    const [summary, setSummary] = useState({
        appointmentSummaries: [],
        entitlementSummaries: [],
    });

    useEffect(() => {
        const get = async () => {
            if (!queryModel.filter) return;

            const input = {
                ...queryModel.filter,
                startDate: Helper.Date.beginOfDay(queryModel.filter.startDate),
                endDate: Helper.Date.endOfDay(queryModel.filter.endDate),
            };
            const res = await ApiService.Entitlement.GetEntitlementGridSummary(input);
            if (res.success) setSummary(res.data);
        };
        get();
    }, [queryModel.updateKey]);

    if (!summary?.appointmentSummaries || summary.appointmentSummaries.length === 0) {
        return null;
    }

    const entitlementSummaries = summary.entitlementSummaries || [];

    return (
        <div style={{
            background: '#fafafa',
            border: '1px solid #e8e8e8',
            borderRadius: 6,
            padding: 12
        }}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 10,
                paddingBottom: 8,
                borderBottom: '1px solid #f0f0f0'
            }}>
                <Text strong style={{ fontSize: 14 }}>{t('General Total')}</Text>
                <Text type="secondary" style={{ fontSize: 11 }}>
                    {summary.appointmentSummaries.length} kur
                </Text>
            </div>

            {summary.appointmentSummaries.map((s, i) => (
                <div
                    key={i}
                    style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: 8,
                        paddingTop: i > 0 ? 8 : 0,
                        marginTop: i > 0 ? 8 : 0,
                        borderTop: i > 0 ? '1px dashed #f0f0f0' : 'none'
                    }}
                >
                    <div>
                        <div style={{ fontSize: 10, color: '#8c8c8c' }}>{t('Price')}</div>
                        <Text style={{ fontSize: 13 }}>
                            {formatPrice(s.totalPrice, { currency: s.currency || 'TRY' })}
                        </Text>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                        <div style={{ fontSize: 10, color: '#8c8c8c' }}>{t('Balance')}</div>
                        <Text strong style={{
                            fontSize: 15,
                            color: s.total > 0 ? '#cf1322' : '#389e0d'
                        }}>
                            {formatPrice(s.total, { currency: s.currency || 'TRY' })}
                        </Text>
                    </div>
                </div>
            ))}

            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                marginTop: 10,
                paddingTop: 8,
                borderTop: '1px solid #f0f0f0'
            }}>
                <div style={{ fontSize: 10, color: '#8c8c8c' }}>{t('Entitlement')}</div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    {entitlementSummaries.map((s, idx) => (
                        <Text key={idx} strong style={{ color: '#1890ff', fontSize: 15 }}>
                            {formatPrice(s.totalEntitlement, { currency: s.currency || 'TRY' })}
                        </Text>
                    ))}
                    {entitlementSummaries.length === 0 && <Text disabled>-</Text>}
                </div>
            </div>
        </div>
    );
};
